// import React, { useEffect, useState } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { FaRocket } from "react-icons/fa";
// import img1 from "./Logo/csg1.png";

// function WelcomeModal1() {
//   const [show, setShow] = useState(true);

//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });
//   }, []);

//   if (!show) return null;

//   return (
//     <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50">
//       <div
//         className="bg-white rounded-2xl shadow-2xl max-w-md w-[90%] p-6 relative overflow-hidden"
//         data-aos="zoom-in"
//       >
//         {/* Close Button */}
//         <button
//           onClick={() => setShow(false)}
//           className="absolute top-3 right-3 text-gray-500 hover:text-red-500 transition"
//         >
//           ✕
//         </button>

//         {/* Logo / Main Image */}
//         <div
//           className="flex justify-center mb-4"
//           data-aos="fade-down"
//           data-aos-delay="200"
//         >
//           <img
//             src={img1}
//             alt="CSG Logo"
//             className="w-48 h-48 md:w-60 md:h-60 object-contain"
//           />
//         </div>

//         {/* Title */}
//         <h2
//           className="text-2xl font-bold text-center text-blue-600 mb-2"
//           data-aos="fade-down"
//           data-aos-delay="300"
//         >
//           Welcome to <span className="text-gray-800">CSG Education</span>
//         </h2>

//         {/* Subtitle */}
//         <p
//           className="text-center text-gray-600 font-medium mb-4"
//           data-aos="fade-up"
//           data-aos-delay="400"
//         >
//           🌟 “CSG – Step Into the Next Level for your future growth” 🌟
//         </p>

//         {/* Footer Button */}
//         <div
//           className="mt-6 flex justify-center"
//           data-aos="fade-up"
//           data-aos-delay="700"
//         >
//           <button
//             onClick={() => setShow(false)}
//             className="bg-blue-600 text-white px-6 py-2 rounded-full flex items-center gap-2 hover:bg-blue-700 transition-all duration-300"
//           >
//             Let’s Get Started <FaRocket className="text-white" />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default WelcomeModal1;

// import React, { useEffect, useState } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { FaRocket } from "react-icons/fa";
// import img1 from "./Logo/csg1.png";

// function WelcomeModal1() {
//   const [show, setShow] = useState(false);

//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });

//     console.log("🟢 useEffect triggered: scheduling welcome modal");

//     const url = new URL(window.location.href);
//     const force = url.searchParams.get("forceModal") === "1";

//     if (force) {
//       console.log("🔧 forceModal=1 present — forcing modal (dev only)");
//       setShow(true);
//       return;
//     }

//     // Always show once after 10s on every refresh/load
//     const timer = setTimeout(() => {
//       setShow(true);
//     }, 1000); // 10 seconds delay

//     // Cleanup timer on unmount
//     return () => clearTimeout(timer);
//   }, []);

//   if (!show) return null;

//   return (
//     <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50">
//       <div
//         className="bg-white rounded-2xl shadow-2xl max-w-md w-[90%] p-6 relative overflow-hidden"
//         data-aos="zoom-in"
//       >
//         {/* Close Button */}
//         <button
//           onClick={() => setShow(false)}
//           className="absolute top-3 right-3 text-gray-500 hover:text-red-500 transition"
//         >
//           ✕
//         </button>

//         {/* Logo / Main Image */}
//         <div
//           className="flex justify-center mb-4"
//           data-aos="fade-down"
//           data-aos-delay="200"
//         >
//           <img
//             src={img1}
//             alt="CSG Logo"
//             className="w-48 h-48 md:w-60 md:h-60 object-contain"
//           />
//         </div>

//         {/* Title */}
//         <h2
//           className="text-2xl font-bold text-center text-blue-600 mb-2"
//           data-aos="fade-down"
//           data-aos-delay="300"
//         >
//           Welcome to <span className="text-gray-800">CSG Education</span>
//         </h2>

//         {/* Subtitle */}
//         <p
//           className="text-center text-gray-600 font-medium mb-4"
//           data-aos="fade-up"
//           data-aos-delay="400"
//         >
//           🌟 “CSG – Step Into the Next Level for your future growth” 🌟
//         </p>

//         {/* Footer Button */}
//         <div
//           className="mt-6 flex justify-center"
//           data-aos="fade-up"
//           data-aos-delay="700"
//         >
//           <button
//             onClick={() => setShow(false)}
//             className="bg-blue-600 text-white px-6 py-2 rounded-full flex items-center gap-2 hover:bg-blue-700 transition-all duration-300"
//           >
//             Let’s Get Started <FaRocket className="text-white" />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default WelcomeModal1;

import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaRocket } from "react-icons/fa";
import img1 from "./Logo/WebLogo.png";

function WelcomeModal1() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    // Protect for SSR / non-window environments
    if (typeof window === "undefined") return;

    // Dev force param to immediately show for testing
    try {
      const url = new URL(window.location.href);
      const force = url.searchParams.get("forceModal") === "1";
      if (force) {
        window.__welcomeModalShown = true; // mark as shown in-memory
        setShow(true);
        return;
      }
    } catch (e) {
      // ignore URL parse errors
    }

    // If modal already shown during this page lifetime, skip
    if (window.__welcomeModalShown) {
      // already shown since this page load (in-memory) — do nothing
      return;
    }

    // Schedule to show once after delay (adjust ms as needed)
    const timer = setTimeout(() => {
      window.__welcomeModalShown = true; // prevent re-show during SPA navigation
      setShow(true);
    }, 1000); // 1000 ms = 1 second; change to 10000 for 10s if desired

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50">
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-md w-[90%] p-6 relative overflow-hidden"
        data-aos="zoom-in"
      >
        {/* Close Button */}
        <button
          onClick={() => setShow(false)}
          className="absolute top-3 right-3 text-gray-500 hover:text-red-500 transition"
        >
          ✕
        </button>

        {/* Logo / Main Image */}
        <div
          className="flex justify-center mb-4"
          data-aos="fade-down"
          data-aos-delay="200"
        >
          <img
            src={img1}
            alt="CSG Logo"
            className="w-48 h-48 md:w-60 md:h-60 object-contain animate-pulse"
          />
        </div>

        {/* Title */}
        <h2
          className="text-2xl font-bold text-center text-blue-600 mb-2"
          data-aos="fade-down"
          data-aos-delay="300"
        >
          Welcome to <span className="text-gray-800">CSG Education</span>
        </h2>

        {/* Subtitle */}
        <p
          className="text-center text-gray-600 font-medium mb-4"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          🌟 “CSG – Step Into the Next Level for your future growth” 🌟
        </p>

        {/* Footer Button */}
        <div
          className="mt-6 flex justify-center"
          data-aos="fade-up"
          data-aos-delay="700"
        >
          <button
            onClick={() => setShow(false)}
            className="bg-blue-600 text-white px-6 py-2 rounded-full flex items-center gap-2 hover:bg-blue-700 transition-all duration-300"
          >
            Let’s Get Started <FaRocket className="text-white" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomeModal1;
